import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { canAddCredits } from "../../lib/userAccess";

/** Next to the credit balance: straight to Products. Both Products and Add credit
 * must be enabled for the account. */
export function AddCreditButton() {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!canAddCredits(user)) return null;
  return (
    <button
      type="button"
      onClick={() => navigate("/products")}
      className="hidden h-9 items-center gap-1.5 rounded-lg bg-brand px-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-hover lg:inline-flex"
    >
      <Plus className="h-4 w-4" /> Add credit
    </button>
  );
}
